import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { getRole } from "../../helpers";

const Table = ({
  apiData,
}) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        date: item.createdAt ? getDateAndTime(item) : '',
        by: getUserInfo(item),
        for: <span className='text-gray-600 text-sm'>{item.for}</span>,
        platform: showPlatform(item.device),
        description: showDescription(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getDateAndTime = (item) => (
    <div className="flex flex-col leading-tight">
      <span className="text-gray-700 text-sm font-medium">
        {moment(item.createdAt).format("DD MMM YYYY")}
      </span>
      <span className="text-gray-400 text-xs">
        {moment(item.createdAt).format("hh:mm A")}
      </span>
    </div>
  );

  const getUserInfo = (item) => (
    <div className="flex flex-col leading-tight">
      <span className="text-gray-800 text-sm font-medium">
        {item?.doneByName || "--"}
      </span>
      <span className="text-gray-400 text-xs">
        {getRole(item?.doneByRole)}
      </span>
    </div>
  );

  const showPlatform = (platform) => {
    const base = "px-2 py-0.5 rounded-full text-xs font-medium";

    if (platform === Config.PLATFORM.ANDROID)
      return <span className={`${base} bg-green-50 text-green-700`}>Android</span>;

    if (platform === Config.PLATFORM.IOS)
      return <span className={`${base} bg-slate-50 text-slate-700`}>iOS</span>;

    return <span className={`${base} bg-blue-50 text-blue-700`}>Web</span>;
  };

  const showDescription = (item) => (
    <div className="flex flex-col">
      <span className="text-gray-700 text-sm leading-relaxed line-clamp-2">
        {item?.description || "--"}
      </span>
    </div>
  );

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Date & Time",
          accessor: "date",
        },

        {
          Header: "Done By",
          accessor: "by",
        },
      ];
    }
    return [

      // {
      //   Header: "Room",
      //   accessor: "room",
      // },
      {
        Header: "Date",
        accessor: "date",
        width: 50
      },
      {
        Header: "Done By",
        accessor: "by",
        width: 50
      },
      {
        Header: "Platform",
        accessor: "platform",
        width: 50
      },
      //   {
      //     Header: "For",
      //     accessor: "for",
      //   },
      {
        Header: "Activity",
        accessor: "description",
        minWidth: 350,
        maxWidth: 1800,
      },

    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  // useEffect(() => {
  //   setPageSize(PaginationLimit);
  // }, []);

  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td {...cell.getCellProps()} style={cell.column.width ? { width: cell.column.width } : {}}>
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">

                        <li>
                          <strong>Activity:</strong> {data[rowIndex].description}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
//const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Td = tw.td`p-3 text-sm md:p-3 text-left align-top`;

const Platform = tw.p`text-gray-600 flex text-sm`;

export default Table;
